import { render, staticRenderFns } from "./UndoButton.vue?vue&type=template&id=80cd665a&scoped=true&"
import script from "./UndoButton.vue?vue&type=script&lang=js&"
export * from "./UndoButton.vue?vue&type=script&lang=js&"
import style0 from "./UndoButton.vue?vue&type=style&index=0&id=80cd665a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cd665a",
  null
  
)

export default component.exports